import { render } from "./DjRechargeTab.vue?vue&type=template&id=0735d004&scoped=true"
import script from "./DjRechargeTab.vue?vue&type=script&lang=js"
export * from "./DjRechargeTab.vue?vue&type=script&lang=js"

import "./DjRechargeTab.vue?vue&type=style&index=0&id=0735d004&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0735d004"

export default script